<style lang="scss">
	.monitorAlertTable .el-progress-bar__outer {
		background: #606672;
	}

	.monitorAlertTable .el-progress__text {
		color: #FFFFFF;
	}


	.monitorAlertTable::before {
		z-index: inherit;
	}

	.monitorAlertTable.el-table {
		background-color: transparent;
	}

	.monitorAlertTable.el-table--border:after,
	.monitorAlertTable.el-table--group:after,
	.monitorAlertTable.el-table:before {
		background-color: transparent;
	}

	.monitorAlertTable.el-table tr {
		background-color: transparent;
	}

	.monitorAlertTable.el-table--enable-row-hover .el-table__body tr:hover>td {

		background-color: #33333A !important;

	}

	.monitorAlertTable .el-table td.gutter,
	.monitorAlertTable.el-table th.gutter {
		background: #33333A;
	}

	.monitorAlertTable .el-table__body-wrapper {
		background: #1D1D24;
	}

	// 滚动条的宽度
	.monitorAlertTable .el-table__body-wrapper::-webkit-scrollbar {
		width: 2px; // 横向滚动条
	}

	// 滚动条的滑块
	.monitorAlertTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
		background-color: #419FFF;
		border-radius: 2px;
	}

	/*滚动条里面轨道*/
	// .monitorAlertTable .el-table__body-wrapper::-webkit-scrollbar-track {
	// 	border-radius: 2px;
	// 	background: #1D1D24;
	// }
</style>
<style lang="scss" scoped="scoped">
	.cell-class-name {
		border-bottom: 1px solid red !important;
	}
</style>

<template>
	<div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
		<div ref="titleBar" class="titleBar"
			style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
			<div style="display: flex;align-items: center;">
				<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
				<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
					{{$t('shishishengchanjindu')}}
				</p>
			</div>
		</div>
		<div :style="{'height':contentHeight+'px'}">
			<el-table ref="table" class="monitorAlertTable" :data="wos" style="width: 100%"
				:max-height="contentHeight" :row-style="{background:'#1D1D24',height:rowHeight+'px'}"
				:cell-style="{padding:0+'px',borderColor:'#202027',color:'#FFFFFF','font-size':'14px'}"
				:header-cell-style="{background:'#33333A',color:'#C0C4CC',padding:'0px', height:'42px',borderColor:'#33333A'}"
				cell-class-name="cell-class-name">
				<el-table-column :label="$t('shebeimingcheng')" width="80">
					<template slot-scope="scope">
						{{$t(scope.row.equipment.name)}}
					</template>
				</el-table-column>
				<el-table-column :show-overflow-tooltip	="true" :label="$t('chanpinmingcheng')+'/'+$t('bianma')">
					<template slot-scope="scope">
						{{$t(scope.row.material.name)}}/{{$t(scope.row.material.code)}}
					</template>
					
				</el-table-column>
				<el-table-column :label="$t('jindu')">
					<template slot-scope="scope">
						<div style="flex: 1;">
							<el-progress 
								:percentage="scope.row.productionQuantity==null?0:parseFloat((scope.row.productionQuantity/scope.row.planQuantity*100).toFixed(1))"
								:color="'#419FFF'">
							</el-progress>
						</div>
					</template>
				</el-table-column>
				
				
			</el-table>
		</div>

	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_cockpit_produce_progress',
		components: {

		},
		watch: {
			'orgId'(newValue, oldValue) {
				if (this.utils.isEqual(newValue, oldValue)) {
					return
				}
				this.listWo()
			},

		},
		props: {
			orgId: {
				type: Number,
				default: null,
			},
		},
		data() {
			return {
				timer: null,
				contentHeight: 0,
				rowHeight: 0,
				wos: [],
			};
		},
		created() {
			this.timer = setInterval(() => {
				this.listWo()
			}, 600000)
			this.listWo()


		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		destroyed() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		},
		methods: {

			async listWo() {
				let response = await this.http.get('/web/production/wo/page', {
					params: {
						flag: 0,
						orgId: this.orgId,
						statusList:[3,5],
					},
				})
				this.wos = response.data.rows
        this.wos.sort((a, b) => {
          const percentageA = parseFloat(
              (a.productionQuantity / a.planQuantity * 100).toFixed(1)
          );
          const percentageB = parseFloat(
              (b.productionQuantity / b.planQuantity * 100).toFixed(1)
          );
          return percentageB - percentageA;
        });
        this.wos = this.wos.slice(0,5)
			},
			
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {
					if (!this.$refs.titleBar) {
						return;
					}
					this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight -
						20 - 20
					this.rowHeight = (this.contentHeight - 42 - 5) / 5
				}, 800)

			},

		}
	};
</script>
